import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service'; // Importa tu AuthService

export const authRedirectGuard: CanActivateFn = async (route) => {
  const auth = inject(Auth);
  const router = inject(Router);
  const authService = inject(AuthService);

  // authStateReady() resuelve una sola vez. Con onAuthStateChanged había que
  // guardar el unsubscribe: sin él cada visita a /auth dejaba un listener vivo
  // que se volvía a ejecutar en cada cambio de sesión.
  await auth.authStateReady();
  const user = auth.currentUser;

  // Sin usuario: dejar entrar al login.
  if (!user) return true;

  const isAuthorized = await authService.checkUserAuthorization(user.uid);
  if (!isAuthorized) {
    authService.showUnauthorizedMessage();
    await authService.signOut();
    return true;
  }

  const returnUrl = route.queryParams['returnUrl'];
  const target = returnUrl && !returnUrl.startsWith('/auth') ? returnUrl : '/boards';
  return router.parseUrl(target);
};
